export const dashboardLightTheme = {
  Menu: {
    itemSelectedBg: '#29b8e3',
    itemSelectedColor: '#fff',
  },
  Layout: {
    headerBg: '#fff',
    // 64 is antd's default. Ten percent off, and the section tabs moved into
    // this row rather than adding one below it.
    headerHeight: 58,
  },
  Table: {
    headerBg: '#F2F4FF',
    headerColor: '#4A4A4C',
    headerSplitColor: '#F2F4FF',
    coloTe: '#5E5F61',
    borderColor: '#F1F2F3',
  },
  List: {
    colorText: '#000',
  },
  Typography: {
    colorTextHeading: '#03060E',
    colorTextDescription: '#5e5f61',
  },
}

export const dashboardDarkTheme = {
  Menu: {
    itemSelectedBg: '#29b8e3',
    itemSelectedColor: '#fff',
    colorBgContainer: '#131B2F',
    itemColor: '#fff',
  },
  Layout: {
    headerHeight: 58,
    headerBg: '#131B2F',
    siderBg: '#131B2F',
    colorBgContainer: '#131B2F',
    bodyBg: '#010912',
  },
  Tabs: {
    colorText: '#fff'
  },
  Drawer: {
    colorBgElevated: "#05152B"
  },
  Modal: {
    contentBg: '#05152B',
    headerBg: '#05152B',
    colorText: '#fff',
    titleColor: '#fff',
    colorIcon: '#fff',
  },
  Select: {
    colorText: "#fff",
    optionSelectedColor: "#000",
    colorBgElevated: "#05152B"
  },
  Collapse: {
    colorBorder: "#0F2F52",
    colorTextHeading: "#fff",
    contentBg: "#95959521",
    //contentBg: "#2F3762"
  },
  Form: {
    labelColor: '#fff',
  },
  List: {
    colorText: '#ffff',
  },
  Card: {
    colorBgContainer: '#05152B',
    colorBorderSecondary: '#05152B',
  },
  Table: {
    headerBg: '#2F3762',
    headerColor: '#fff',
    headerSplitColor: '#2F3762',
    borderColor: '#0F2F52',
    colorBgContainer: '',
    colorText: '#fff',
  },
  Typography: {
    colorText: '#fff',
    colorTextHeading: '#fff',
    colorTextDescription: '#D2D4D8',
  },
}
